import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import TestKitTracker from "../ProgressBars/TestKitTracker";
import { formatDateTime, trimAllWhiteSpaces } from "../../utils/utils";
import { useMediaQuery } from "react-responsive";
import { royalMailTrackingUrl } from "../../utils/constants";
import PropTypes from "prop-types";
const TestKitTrackerCard = ({ test, cardTitle = null, isNotDna = true }) => {
  const { date: activationDate, time: activationTime } = formatDateTime(
    test?.activated_ts,
  );
  const { date: sampleDate, time: sampleTime } = formatDateTime(
    test?.primary_received,
  );
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [totalCompletedSteps, setTotalCompletedSteps] = useState(0);
  const activationBeganAt = new Date(test.activated_ts);
  const now = new Date();
  const TWELVE_HOURS_IN_MS = 12 * 60 * 60 * 1000;
  const trackingUrl = trimAllWhiteSpaces(
    royalMailTrackingUrl(test?.postage_tracking),
  );

  useEffect(() => {
    if (test.test_kit_status === "activated") {
      if (now - activationBeganAt > TWELVE_HOURS_IN_MS) {
        setTotalCompletedSteps(1);
      } else {
        setTotalCompletedSteps(0);
      }
    } else if (test.test_kit_status === "processing") {
      setTotalCompletedSteps(2);
    } else if (test.test_kit_status === "report-in-review") {
      setTotalCompletedSteps(3);
    }
  }, [test, activationBeganAt, now]);

  if (test.test_kit_status === "report-ready") return null;

  const stepDateTimes = {
    0: test ? { date: activationDate, time: activationTime } : null,
    ...(isNotDna && {
      2: test?.primary_received
        ? { date: sampleDate, time: sampleTime }
        : null,
    }),
  };

  const dateTimeMessage = (stepIndex) => {
    const stepDateTime = stepDateTimes[stepIndex];
    if (!stepDateTime) return null;

    return (
      <div className="card date-time-message">
        <div className="container-fluid">
          <div className="row d-flex">
            <span className="date">
              Date : <span className="text-bold">{stepDateTime.date}</span>
            </span>
            <span className="time">
              Time : <span className="text-bold">{stepDateTime.time}</span>
            </span>
            {test?.bid === null ? (
              <a className="order-tracking" href={trackingUrl} target="_blank" rel="noopener noreferrer">
                {isMobile ? "order tracking" : "track order"}
              </a>
            ) : ""}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {test?.type_name && <p className="ageo-semibold text-teal test-tracker-title">{test?.type_name}</p>}
      <Card className={`test-kit-tracker-card mt-0 ${isMobile && "stat-mobile-card"}`}>
        <Card.Body>
          {isMobile && cardTitle}
          <TestKitTracker
            totalSteps={isNotDna ? 5 : 4}
            currentStepStatus={true}
            totalCompletedSteps={totalCompletedSteps}
            isReoportPublished={false}
            dateTimeMessage={dateTimeMessage}
            isMobile={isMobile}
            isNotDna={isNotDna}
          />
        </Card.Body>
      </Card>
    </>
  );
};

TestKitTrackerCard.propTypes = {
  test: PropTypes.shape({
    test_ts: PropTypes.string,
    activated_ts: PropTypes.string,
    test: PropTypes.string,
    primary_received: PropTypes.string,
    test_kit_status: PropTypes.string.isRequired,
    postage_tracking: PropTypes.string,
    bid: PropTypes.string,
  }).isRequired,
  cardTitle: PropTypes.node,
};

export default TestKitTrackerCard;
